import fonts from './_fonts'
import lazyLoad from './components/_lazyLoad'
import featuredSlider from './components/_featured-slider'
import map from './components/_map'
import accordion from './components/_accordion'

function init () {
  lazyLoad()
  fonts()
  featuredSlider()
  accordion()
  window.initMap = map
}

jQuery(document).ready(function ($) {
  $('.accordion').on('click', '.accordion--item--title', function (e) {
    e.preventDefault()
    $(this)
      .next('.accordion--item--content')
      .not(':animated')
      .slideToggle()
  })

  // menu toggle
  $('.hamburger').on('click', function (e) {
    $('.header--nav').toggleClass('active')
    $('.hamburger').toggleClass('active')
    e.preventDefault()
  })

  // mobile sub menu
  $('.header--nav ul li .sub-menu').hide()
  $('.header--nav ul li.menu-item-has-children a')[0].onclick = function (event) {
    event.preventDefault()
    $(this)
      .closest('li')
      .find('.sub-menu')
      .first()
      .slideToggle()
  }
})

init()



// WEBPACK FOOTER //
// ./src/js/main.js